






























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class Modal extends Vue {
  @Prop({ required: false, type: Boolean, default: false })
  private show!: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  private embedded!: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  private fixed!: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  private nopad!: boolean;

  @Prop({ required: false, type: String, default: '' })
  private title!: string;

  private close() {
    this.$emit('close');
  }

  private mounted() {
    document.addEventListener('keydown', (e) => {
      if (this.show && e.keyCode == 27) {
        this.close();
      }
    });
  }
}
